/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Hard_NoteInputs */

const en_funnel_ob_ben_hard_note = /** @type {(inputs: Funnel_Ob_Ben_Hard_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The highlight keeps you on track, word by word`)
};

const es_funnel_ob_ben_hard_note = /** @type {(inputs: Funnel_Ob_Ben_Hard_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El resaltado te guía palabra por palabra`)
};

/**
* | output |
* | --- |
* | "The highlight keeps you on track, word by word" |
*
* @param {Funnel_Ob_Ben_Hard_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_hard_note = /** @type {((inputs?: Funnel_Ob_Ben_Hard_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Hard_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_hard_note(inputs)
	return en_funnel_ob_ben_hard_note(inputs)
});